import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import { platformSelect } from '@bubble-ui/util-platform';
export var contentWithoutLayoutCalculation = fields => fields.map((field, index) => {
  var {
    Component,
    props
  } = field;
  return /*#__PURE__*/React.createElement(View, {
    key: props.name !== undefined ? props.name : index,
    style: _objectSpread({}, platformSelect({
      web: {
        zIndex: 'auto'
      },
      default: {}
    }))
  }, /*#__PURE__*/React.createElement(Component, props), index + 1 < fields.length && /*#__PURE__*/React.createElement(SpacerVertical, {
    spaceToken: "space/200"
  }));
});
//# sourceMappingURL=contentWithoutLayoutCalculation.js.map